var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.reasons),function(reason,index){return _c('div',{key:("reason-" + reason + "-" + index),staticClass:"mr-2"},[_c('ExplainabilityBadge',{attrs:{"title":reason}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }